import { Link } from 'react-router-dom'
import React, { useState, useEffect } from 'react'

import Timer from 'components/Icons/timer'
import { SectionWithHeading } from './SectionBlock.style'

const HomepageCountdown = ({ date }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(date) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
      }
    }
    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearTimeout(timer)
  })

  const { days, hours, minutes } = timeLeft

  if (!days && !hours && !minutes) {
    return null
  }

  return (
    <span className="flex items-center gap-1">
      დარჩა:
      {days > 0 && <span>{days} დღე</span>}
      {hours > 0 && <span>{hours}სთ</span>}
      {minutes > 0 && <span>{minutes}წთ</span>}
    </span>
  )
}

export const BannerSection = ({ banners, position = 'after' }) => {
  const bannerList = banners?.[position] || []
  if (!bannerList.length) return null

  const getBannerImage = banner => {
    const isMobile = window.innerWidth < 1100
    return isMobile && banner.mobile_image ? banner.mobile_image : banner.image
  }

  return (
    <div>
      <div className="banners flex items-center justify-center gap-4 my-4">
        {bannerList.map(banner => {
          const bannerImage = getBannerImage(banner)
          if (position === 'before') {
            return (
              <img
                key={banner.id}
                src={bannerImage}
                alt={banner.text || 'Banner'}
                className="rounded-lg"
              />
            )
          }
          return (
            <Link key={banner.id} to={banner.url || '#'}>
              <img
                src={bannerImage}
                alt={banner.text || 'Banner'}
                className="rounded-lg"
              />
            </Link>
          )
        })}
      </div>
    </div>
  )
}

const SectionHeader = ({ title, id, countdown }) => {
  const hasCountdown = countdown && new Date(countdown) > new Date()

  return (
    <div
      className={`flex ${
        hasCountdown
          ? 'flex-row justify-between items-center'
          : 'flex-col sm:flex-row'
      } justify-between items-start gap-3 md:mb-2`}
    >
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-800">
          {id ? (
            <Link
              to={`/products/${id}`}
              className="hover:text-slate-600 transition-colors duration-200 cursor-pointer"
            >
              {title}
            </Link>
          ) : (
            title
          )}
        </h2>
      </div>
      <div className="flex flex-row items-start sm:items-center gap-3 sm:gap-4">
        {hasCountdown && (
          <div className="bg-[linear-gradient(to_right_top,rgb(254,242,242),rgb(254,226,226))] text-red-600 px-3 py-1.5 rounded-full font-semibold text-[13px] flex items-center gap-1 sm:gap-2 animate-pulse whitespace-nowrap">
            <Timer className="pb-[1px]" />
            <HomepageCountdown date={countdown} />
          </div>
        )}
      </div>
    </div>
  )
}

const SectionBlock = props => {
  const {
    title,
    countdown,
    linkText,
    link,
    titleComponent,
    id,
    children,
    icon,
    ...rest
  } = props

  return (
    <SectionWithHeading {...rest}>
      <SectionHeader
        title={title}
        id={id}
        countdown={countdown}
        link={link}
        linkText={linkText}
        titleComponent={titleComponent}
      />

      {children}
    </SectionWithHeading>
  )
}

export default SectionBlock
